import { integrationScriptLoadState, action } from '@core/js/hooks/auth/pas';

export {
    integrationScriptLoadState,
    action,
    init,
    forgotPassToken,
    getTempToken,
    getWaitingMessages,
    logout,
    changePassword,
    setTerms,
    forgotPassword,
    getLoggedInPlayer,
    loginExternalToken,
    validateTwoFactorToken,
    validateGeolocation,
    validatePin,
    validateFitToPlayToken,
    resendLogin2FAToken,
    setIovationBlackbox,
    setDeviceId,
    setDeliveryPlatform,
    setClientPlatform,
    setClientType,
    registrationBankId,
    loginBankId,
    validateSessionBankId,
    cancelBankId,
    validateChallengeAnswer,
    setLoginType,
    getFitToPlaySubmissionRequired,
    validateMfaToken
} from '@core/js/hooks/auth/pas';

export const login = (options, responseParam) => {
    let loginAction = 'iapiLoginAndGetTempToken';
    let callbackName = 'iapiCALLOUT_LOGINANDGETTEMPTOKEN';
    let needsTokenRequest = false;

    switch (options.loginMode) {
        case 'email': {
            loginAction = 'iapiEmailLoginAndGetTempToken';
            break;
        }

        case 'externalToken': {
            loginAction = 'iapiLoginExternalTokenAndGetTempToken';
            break;
        }

        case 'printedTokenCode': {
            // change to iapiLoginPrintedIdTokenCodeAndPinAndGetTempToken once it is done by IMS
            loginAction = 'iapiLoginPrintedIdTokenCodeAndPin';
            callbackName = 'iapiCALLOUT_LOGIN';
            needsTokenRequest = true;
            break;
        }

        default: {
            break;
        }
    }
    // #region @theme
    if (options.loginMode === 'fidoAuthUi') {
        return action(
            'iapiLoginUsernameExternalToken', 'iapiCALLOUT_LOGIN',
            [responseParam.username, responseParam.externalToken, 1, options.languageTwoLetter]);
    }
    // #endregion

    let params = [
        options.userName, options.password, 1, options.languageCode
    ];

    if (typeof options.rememberMeLogin === 'boolean') {
        params = params.concat([null, null, options.rememberMeLogin]);
    }

    return action(loginAction, callbackName, params)
        .catch((error) => {
            const response = error.response || error;

            if (response?.data?.sessionValidationData) {
                return response;
            }

            return Promise.reject(error);
        })
        .then(async (response) => {
            if (needsTokenRequest) {
                response.data.needsTokenRequest = true;
            }

            return response;
        });
};

export const setClientChannel = clientChanel => integrationScriptLoadState
    .then(() => window.iapiSetClientChannel(clientChanel));

export const iapiLoginUsernameExternalToken = options => action(
    'iapiLoginUsernameExternalToken', 'iapiCALLOUT_LOGIN',
    [options.user, options.sessionToken, 1, options.languageCode]
);
